//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'OpValueRange',
  props: {
    title: {
      type: String,
      required: false,
      default: ""
    }
  },
  data: function data() {
    return {
      options: [{
        value: 'ge',
        label: '≥'
      }, {
        value: 'le',
        label: '≤'
      }, {
        value: 'eq',
        label: '='
      }, {
        value: 'gt',
        label: '>'
      }, {
        value: 'lt',
        label: '<'
      }],
      selectValue: 'ge',
      inputValue: ''
    };
  },
  watch: {
    selectValue: function selectValue() {
      var obj = {
        operator: this.selectValue,
        value: this.inputValue
      };
      this.$emit("input", obj);
    },
    inputValue: function inputValue() {
      var obj = {
        operator: this.selectValue,
        value: this.inputValue
      };
      this.$emit("input", obj);
    }
  }
};